import { Box,Grid } from '@mui/material';
import './Footer.css'
import PageURL from '../../PageURL';
import { Context } from '../../Context';
import React from 'react';
import PageTab from '../PageTab/PageTab';
function Footer() {
    const {setPageChange} = React.useContext(Context);
    const tabs = React.useMemo(()=>PageURL.map(({name,url},index)=>{
       return <Grid item key={'footer '+name} onClick={()=>setPageChange(index)}><PageTab name={name} url={url}/></Grid>
    }),[])
    return <div id='Footer'>
        <Box className="divider" sx={{backgroundColor:'divider'}}></Box>
        <Grid container direction={'row'} spacing={2} className='pageTabContainer' sx={{fontSize:13}}>
            {tabs}
            <Grid item sx={{marginLeft:'auto'}}>Created by Quan.dev</Grid>
        </Grid>
    </div>;
}

export default Footer;